import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Modal,
  FormControl,
  Menu,
  MenuItem as MuiMenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TablePagination,
} from "@mui/material";
import { MoreVert } from "@mui/icons-material";
import { ModalClose, Sheet, Stack, Typography } from "@mui/joy";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useUpdate, useDelete } from "../../hooks";

export default function AdminStatus() {
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStatusId, setSelectedStatusId] = useState(null);
  const [trackingNumber, setTrackingNumber] = useState("");
  const [statuses, setStatuses] = useState("");
  const [modalAction, setModalAction] = useState("");
  const [data, setData] = useState([]);
  const [name, setName] = useState("");
  const [moduleStatus, setModuleStatus] = useState("");
  const [nameError, setNameError] = useState("");
  const [statusError, setStatusError] = useState("");
  const [isEditMode, setEditMode] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  const loginToken = useSelector((state) => state.user.logintoken);

  //getAllStatus
  const {
    data: statusData,
    isLoading: isStatusLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllStatus"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: createStatusData,
    isLoading: createStatusLoading,
    error: createStatusError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createStatus"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateStatusData,
    isLoading: updateStatusLoading,
    error: updateStatusError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deleteStatusData,
    isLoading: deleteStatusLoading,
    error: deleteStatusError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  useEffect(() => {
    fetchData();
  }, []);

  const clearErrors = () => {
    setNameError("");
    setStatusError("");
  };
  useEffect(() => {
    if (error) {
    } else if (statusData && statusData["status"] === true) {
      console.log("usersData", statusData["data"]);
      setData(statusData["data"]);
    }
  }, [statusData, error]);

  //Create User
  useEffect(() => {
    if (createStatusError) {
    } else if (createStatusData && createStatusData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: createStatusData["message"],
        status: createStatusData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (createStatusData && createStatusData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: createStatusData["message"],
        status: createStatusData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [createStatusData, createStatusError]);

  //Update User
  useEffect(() => {
    if (updateStatusError) {
    } else if (updateStatusData && updateStatusData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: updateStatusData["message"],
        status: updateStatusData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (updateStatusData && updateStatusData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: updateStatusData["message"],
        status: updateStatusData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateStatusData, updateStatusError]);

  //Delete Roles
  useEffect(() => {
    if (deleteStatusError) {
    } else if (deleteStatusData && deleteStatusData["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: deleteStatusData["message"],
        status: deleteStatusData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    } else if (deleteStatusData && deleteStatusData["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: deleteStatusData["message"],
        status: deleteStatusData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    }
  }, [deleteStatusData, deleteStatusError]);

  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };

  // Filter data based on search
  const filteredData =
    data && data.length > 0
      ? data
          .sort((a, b) => b.status_id - a.status_id) // Sort by ID in descending order, latest ID first
          .filter(
            (item) =>
              (item.status_id &&
                item.status_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.name &&
                item.name.toLowerCase().includes(search.toLowerCase()))
          )
      : data;

  const handleMenuOpen = (event, statusId) => {
    setAnchorEl(event.currentTarget);
    setSelectedStatusId(statusId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedStatusId(null);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleAddClick = () => {
    setSelectedStatusId(null);
    setModalAction("Add");
    setOpen(true);
  };

  const handleEdit = (status) => {
    setOpen(true);
    setModalAction("Edit");
    setEditMode(true);
    clearErrors();
    setName(status.name || "");
    setModuleStatus(status.options || "");
  };
  // Handle delete
  const handleDelete = (statusId) => {
    const deleteUrl = urls("deleteStatus", statusId);
    fetchDeleteData(deleteUrl);
  };

  const handleModalSubmit = () => {
    if (!name.trim()) {
      setNameError("Name is required.");
      return;
    }

    if (!moduleStatus.trim()) {
      setNameError("");
      setStatusError("Status is required.");
      return;
    }

    const saveBody = {
      name: name,
      options: moduleStatus,
    };
    if (isEditMode) {
      const updateUrl = urls("updateStatus", selectedStatusId);
      fetchUpdateData(updateUrl, saveBody);
    } else {
      fetchCreateData(saveBody);
    }
  };

  //close button
  const handleClose = () => {
    setModalOpen(false);
    setDeleteModalOpen(false);
    clearErrors();
    setName("");
    setModuleStatus("");
    setSnackbarState({
      message: "",
      status: "",
    });
  };

  return (
    <Box sx={{ bgcolor: "white", p: 2 }}>
      <Box
        sx={{
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          mt={2}
        >
          <TextField
            variant="outlined"
            placeholder="Search"
            size="small"
            value={search}
            onChange={handleSearch}
            sx={{
              width: "30%",
              backgroundColor: "#FFF",
              borderRadius: 1,
            }}
          />

          <Button
            variant="contained"
            startIcon={<AddCircleOutlineIcon />}
            onClick={handleAddClick}
            sx={{
              bgcolor: "#00796b",
              color: "#ffffff", // White text color
              "&:hover": { bgcolor: "#005a4f" },
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
              borderRadius: "8px",
            }}
          >
            Add
          </Button>
        </Box>
      </Box>
      {/* Status Table */}
      <TableContainer component={Paper} sx={{ mt: 3 }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#00796b" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", color: "white" }}>
                ID
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "white" }}>
                Name
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "white" }}>
                STATUS
              </TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "white" }}>
                ACTIONS
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  <Typography>No records found</Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredData.map((status) => {
                return (
                  <TableRow key={status.status_id}>
                    <TableCell>{status.status_id}</TableCell>
                    <TableCell>{status.name}</TableCell>
                    <TableCell>
                      {Array.isArray(status.options)
                        ? status.options.join(", ")
                        : status.options}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={(e) => handleMenuOpen(e, status.status_id)}
                      >
                        <MoreVert />
                      </IconButton>
                      <Menu
                        anchorEl={anchorEl}
                        open={
                          Boolean(anchorEl) &&
                          selectedStatusId === status.status_id
                        }
                        onClose={handleMenuClose}
                      >
                        <MuiMenuItem onClick={() => handleEdit(status)}>
                          Edit
                        </MuiMenuItem>
                        {/* <MuiMenuItem
                          onClick={() => handleDelete(status.status_id)}
                        >
                          Delete
                        </MuiMenuItem> */}
                        {/*commented on 26-01-25 because for status delete should not be there as per discussion*/}
                      </Menu>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={data && data.length ? data.length : 0}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
      <Dialog
        open={isDeleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      >
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.status === true
              ? snackbarState.message
              : deleteStatusError}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add/Edit Modal */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        BackdropProps={{
          style: { backgroundColor: "rgba(0, 0, 0, 0.2)" },
        }}
      >
        <Sheet
          variant="outlined"
          sx={{
            maxWidth: "500px",
            width: "100%",
            borderRadius: "md",
            p: 3,
          }}
        >
          <ModalClose
            variant="plain"
            sx={{ m: 1 }}
            onClick={() => setOpen(false)}
          />
          <Typography
            sx={{ fontSize: 20, textAlign: "center", fontWeight: "bold" }}
          >
            {modalAction === "Add" ? "Add Status" : "Edit Status"}
          </Typography>

          <Stack sx={{ gap: 2 }}>
            <FormControl fullWidth>
              <TextField
                label="Name"
                variant="outlined"
                size="small"
                sx={{ mb: 2 }}
                value={name}
                onChange={(e) => setName(e.target.value)}
                error={!!nameError}
                helperText={
                  nameError && (
                    <Typography
                      sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                    >
                      {nameError}
                    </Typography>
                  )
                }
              />
            </FormControl>

            <TextField
              fullWidth
              label="Status"
              variant="outlined"
              value={moduleStatus}
              onChange={(e) => setModuleStatus(e.target.value)}
              size="small"
              placeholder="Enter statuses, e.g., Pending, Confirmed"
              sx={{ mb: 2 }}
              error={!!statusError}
              helperText={
                statusError && (
                  <Typography
                    sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                  >
                    {statusError}
                  </Typography>
                )
              }
            />

            <Button
              sx={{
                backgroundColor: modalAction === "Add" ? "#4CAF50" : "#4F46E5",
                "&:hover": {
                  backgroundColor:
                    modalAction === "Add" ? "#388E3C" : "#3B3DBB",
                },
              }}
              onClick={handleModalSubmit}
            >
              {modalAction === "Add" ? "Add" : "Update"}
            </Button>
          </Stack>
        </Sheet>
      </Modal>
      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
